import projects from "../db/projects.json";

const getProjects = () => {
  return projects;
};

export default getProjects;
